import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Employee from './form';

const EmployeesFormView = ({
  t,
  employee,
  customs,
  company,
  handleSubmit,
  handleValueChange,
  handleDependentChange,
  handleValidation,
  handleAddCustomField,
  handleRemoveCustomField,
  subcompany,
  isFetching,
  isSubmitted,
  isSaving,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      <Common.Header title={t('custom_fields_employees.employees_title')} />
      <div className="col-12">
        <Common.Portlet
          title={t(employee.id ? 'custom_fields_employees.edit' : 'custom_fields_employees.add')}
          icon={'archive'}
        >
          <Employee.Form
            company={company}
            handleSubmit={handleSubmit}
            handleValidation={handleValidation}
            handleValueChange={handleValueChange}
            handleDependentChange={handleDependentChange}
            handleAddCustomField={handleAddCustomField}
            handleRemoveCustomField={handleRemoveCustomField}
            isSubmitted={isSubmitted}
            isSaving={isSaving}
            subcompany={subcompany}
            values={employee}
            customs={customs}
          />
          <Common.LoaderOverlay show={isFetching} />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(EmployeesFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/EmployeeFormView.js